import { PagePlaceholder } from "../page-placeholder/page-placeholder";

export function Highscores(): JSX.Element {
  return <PagePlaceholder title="Highscores" />;
}
